import { useCallback, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Editor } from "@/components";
import routes from "@/constants/routes";
import PageLoading from "@/components/page-loading/PageLoading";
import NotFound from "@/pages/menu/components/NotFound";
import { useLazyFetchElementsQuery, useLazyFetchTemplateByIdQuery, useUpdateElementMutation, useUpdateTemplateMutation } from "@/features/templates/templatesApi";
import "./styles.scss";

const TemplateEditor = () => {
  const navigate = useNavigate();
  const { templateId, elementId } = useParams<{ templateId: string; elementId?: string }>();
  const [fetchTemplate, templateMutation] = useLazyFetchTemplateByIdQuery();
  const [fetchElements, elementsMutation] = useLazyFetchElementsQuery();
  const [updateWebElement] = useUpdateElementMutation();
  const [updateTemplate] = useUpdateTemplateMutation();

  const fetchInitialData = useCallback(async () => {
    await fetchTemplate(templateId);
    await fetchElements(templateId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const saveTemplate = (data: string) => {
    if (!templateMutation?.data || !templateId) return;

    if (elementId) {
      updateWebElement({
        templateId,
        payload: {
          id: elementId,
          data: data,
        },
      });
    } else {
      updateTemplate({ templateId, data });
    }
  };

  const handleClose = () => {
    navigate(routes.templates.main);
  };

  useEffect(() => {
    if (templateId) {
      fetchInitialData();
    }
  }, [fetchInitialData, templateId]);

  if (templateMutation.isLoading || elementsMutation.isLoading) {
    return <PageLoading />;
  }

  if (!templateMutation?.data) {
    return <NotFound title="Plantilla no encontrada" description="Elige otra plantilla" />;
  }

  return (
    <Editor
      title={templateMutation.data.title}
      data={templateMutation.data?.data ?? ""}
      template={templateMutation.data}
      elements={elementsMutation.data}
      onSave={saveTemplate}
      onClose={handleClose}
    />
  );
};

export default TemplateEditor;
